import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import './login.css'; 

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // Para mostrar errores

  // Obtener credenciales almacenadas en variables de entorno
  const storedEmail = process.env.REACT_APP_USERNAME;
  const storedPassword = process.env.REACT_APP_PASSWORD;

  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Mostrar los valores en la consola para verificar
    console.log('data email receive');

  
    // Validar credenciales
    if (email === storedEmail && password === storedPassword) {
      setError(''); // Limpiar errores si todo está bien
      console.log('Inicio de sesión exitoso');
      
      // Llamar a onLogin en lugar de redirigir manualmente
      onLogin(true); // Esto actualizará isAuthenticated en App.js
    } else {
      setError('Credenciales incorrectas. Inténtalo de nuevo.');
      console.log('Credenciales incorrectas');
    }
  };

  return (
    <div className="login-page">
      <Container fluid className="d-flex flex-column align-items-center justify-content-center vh-100">
        <Row className="text-center mb-4">
          <Col>
            <img
              src="/assets/img/logo.png" // Cambia esto por la ruta de tu logo
              alt="Logo de la compañía"
              className="company-logo mb-3"
            />
            <h1 className="company-name">Sistemas Aliados</h1>
          </Col>
        </Row>
        <Row className="w-100">
          <Col
            xs={12}
            md={8}
            lg={6}
            xl={4}
            className="mx-auto d-flex justify-content-center"
          >
            <Form
              className="bg-light rounded shadow p-4"
              style={{ maxWidth: '400px', width: '100%' }}
              onSubmit={handleSubmit}
            >
              {error && <p className="text-danger text-center mb-3">{error}</p>}
              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Ingresa tu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formPassword" className="mb-3">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              <Button variant="dark" type="submit" className="w-100">
                Iniciar sesión
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
